import { Button, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import CustomProductActionBottom from "../CustomProductActionBottom";
import { useWatch } from "react-hook-form";
import customSortArrays from "../../unit/sortArrays";

export default function Servicing({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  // const sectionName = "servicing";
  const sectionName = "servicing_disbursement";
  let sectionTitle =
    "Servicing - Provide accounts used for disbursement and repayments";
  const sectionSubtitle = "";
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  if (productType == "account") {
    sectionTitle =
      "Servicing - Designated process and accounts used for transferring payments";
  } else if (subType == "securedcreditcard") {
    sectionTitle = "Servicing - Provide accounts used for repayments";
  } else {
    sectionTitle =
      "Servicing - Provide accounts used for disbursement and repayments";
  }

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.servicing;
  const accountList = data?.accountList;

  type Account = {
    id?: string;
    sInstitutionName?: string;
    sAccountType?: string;
    sAccountNumber?: string;
    sRoutingNumber?: string;
  };

  const accountRepaymentOptions: any[] | undefined = [];
  if (accountList) {
    Object.entries(accountList).forEach(([key, value]) => {
      const account = value as Account;
      accountRepaymentOptions.push({
        value: account?.id,
        label:
          (account?.sInstitutionName || "") +
          " " +
          (account?.sAccountType || "") +
          " " +
          (account?.sAccountNumber || ""),
      });
    });
  }
  const accountOptions: any[] | undefined = [];
  if (accountList) {
    Object.entries(accountList).forEach(([key, value]) => {
      const account = value as Account;
      accountOptions.push({
        value: account?.id,
        label:
          (account?.sInstitutionName || "") +
          " " +
          (account?.sAccountType || "") +
          " " +
          (account?.sAccountNumber || ""),
      });
    });
  }
  accountOptions.push({
    value: "dwolla_balance",
    label: "Dwolla Balance",
  });
  const [isActualDirty, setIsActualDirty] = React.useState(false);
  const [showStep3, setShowStep3] = React.useState(false);
  const [showStep4, setShowStep4] = React.useState(false);
  const [showStep5, setShowStep5] = React.useState(false);
  const [showStep6, setShowStep6] = React.useState(false);
  const [showAccountType, setShowAccountType] = React.useState(false);

  const [showRepaymentStep2, setShowRepaymentStep2] = React.useState(false);
  const [showRepaymentStep3, setShowRepaymentStep3] = React.useState(false);
  const [showRepaymentStep4, setShowRepaymentStep4] = React.useState(false);
  const [showRepaymentStep5, setShowRepaymentStep5] = React.useState(false);
  const [showRepaymentStep6, setShowRepaymentStep6] = React.useState(false);
  const [showRepaymentStep5AccountType, setShowRepaymentStep5AccountType] =
    React.useState(false);
  const [showRepaymentStep5AccountId, setShowRepaymentStep5AccountId] =
    React.useState(false);

  const initialValuesSet = {
    disbursement_time: data?.disbursement_time || "",
    disbursement_ach1: data?.disbursement_ach1 || "",
    disbursement_to_account: data?.disbursement_to_account || "",
    disbursement_account_type: data?.disbursement_account_type || "",
    disbursement_ach: data?.disbursement_ach || "",
    disbursement_collect: data?.disbursement_collect || "",
    use_disbursement_account: data?.use_disbursement_account || "",
    // repayment_ach: data?.repayment_ach || "",
    // repayment_smart_ach: data?.repayment_smart_ach || "",
    // repayment_collect: data?.repayment_collect || "",
    // deposit_collect: data?.deposit_collect || "",
    // sProductAlerts: data?.sProductAlerts || "",
    // repayment_to_account: data?.repayment_to_account || "",
    // repayment_account_type: data?.repayment_account_type || "",
    // use_repayment_account: data?.use_repayment_account || "",
    // sVerifiedFundingSource: data?.sVerifiedFundingSource || "",
  };
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: "onBlur",
    defaultValues: initialValuesSet,
  });
  React.useEffect(() => {
    if (data) {
      reset(initialValuesSet);

      if (data?.disbursement_ach1 == "NO_ACH") {
        setShowStep3(false);
        setShowStep4(false);
        setShowStep5(false);
        setShowStep6(false);
      } else {
        setShowStep3(true);
      }
      if (data?.disbursement_to_account == "disbursement_lender_account") {
        setShowStep4(false);
        setShowStep5(false);
        setShowStep6(false);
      } else {
        setShowStep4(true);
        setShowStep5(true);
      }
      if (data?.disbursement_to_account == "disbursement_lender_account") {
        setShowAccountType(true);
      } else {
        setShowAccountType(false);
      }

      if (data?.disbursement_ach == "NO") {
        setShowStep6(false);
      } else {
        setShowStep6(true);
      }
    }
  }, [data, reset]);

  const allValues = useWatch({ control });

  React.useEffect(() => {
    const hasChanges =
      JSON.stringify(customSortArrays(initialValuesSet)) !==
      JSON.stringify(customSortArrays(allValues));
    setIsActualDirty(hasChanges);

    // console.log("Check 是否有修改====>:", hasChanges);
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, hasChanges);
    }
  }, [allValues]);

  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  //disbursement 值的变化互相影响
  const onChangeDisbursementStep2 = () => {
    console.log("onChangeDisbursementStep2 ", getValues("disbursement_ach1"));
    if (getValues("disbursement_ach1") == "NO_ACH") {
      console.log("onChangeDisbursementStep2 NO");
      setValue("disbursement_to_account", ""); //step 3
      setValue("disbursement_ach", "NO"); //step 4
      setValue("disbursement_collect", "NO"); //step 5
      setValue("use_disbursement_account", ""); //step 6
    }
  };
  const onChangeDisbursementStep3 = () => {
    if (getValues("disbursement_to_account") == "disbursement_lender_account") {
      setValue("disbursement_ach", "NO"); //step 4
      setValue("disbursement_collect", "NO"); //step 5
      setValue("use_disbursement_account", ""); //step 6
    }
  };
  const onChangeDisbursementStep4 = () => {
    if (getValues("disbursement_ach") == "NO") {
      setValue("use_disbursement_account", ""); //step 6
    }
  };

  const disbursementAccountOptions: any[] = [];
  if (subType == "car" || subType == "purchase") {
    disbursementAccountOptions.push({
      value: "disbursement_vendor_account",
      label: "Vendor's registered depository account on Happy Mango",
    });
  }
  disbursementAccountOptions.push({
    value: "disbursement_user_account",
    label:
      "Borrower existing depository account outside of my institution that is connected to Happy Mango",
  });
  disbursementAccountOptions.push({
    value: "disbursement_lender_account",
    label: "Borrower depository account opened by my institution",
  });
  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />
      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {productType != "account" && subType != "securedcreditcard" && (
          <Box id="serviceDisbursementSection">
            <Grid
              container
              sx={{ backgroundColor: "#f5f5f5", padding: "10px", mb: 2 }}
            >
              <Grid item xs={12}>
                <FieldTitle
                  title={
                    "Disbursement - Requirements for disbursing funds to individual"
                  }
                />
              </Grid>
            </Grid>
            {/* Step 1 */}
            <Grid container spacing={2} sx={{ mb: 1 }}>
              <Grid item xs={12}>
                {/* disbursement_time, selecte, inception, maturity */}
                <Controller
                  name={`disbursement_time`}
                  // defaultValue={textreader}
                  control={control}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      sx={{ maxWidth: "800px" }}
                      label="1. When does disbursement take place?"
                      variant="outlined"
                      optionlist={[
                        { value: "inception", label: "At inception of loan" },
                        { value: "maturity", label: "At maturity of loan" },
                      ]}
                    />
                  )}
                />
              </Grid>
            </Grid>
            {/* Step 2, 2. Will disbursement be made through ACH?, disbursement_ach1, ACH:YES, NO_ACH:NO */}
            <Grid container spacing={2} sx={{ mb: 1 }}>
              <Grid item xs={12}>
                <Controller
                  name={`disbursement_ach1`}
                  control={control}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      sx={{ maxWidth: "800px" }}
                      label="2. Will disbursement be made through ACH?"
                      variant="outlined"
                      optionlist={[
                        { value: "ACH", label: "YES" },
                        { value: "NO_ACH", label: "NO" },
                      ]}
                      onChange={(e) => {
                        setValue(
                          "disbursement_ach1",
                          e.target.value.toString()
                        );
                        if (e.target.value.toString() == "NO_ACH") {
                          setShowStep3(false);
                          setShowStep4(false);
                          setShowStep5(false);
                          setShowStep6(false);
                        } else {
                          setShowStep3(true);
                        }
                        onChangeDisbursementStep2();
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            {/* Step 3 */}
            {showStep3 && (
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={9}>
                  <Controller
                    name={`disbursement_to_account`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        fullWidth
                        sx={{ maxWidth: "800px" }}
                        label="3. Please select destination account into which funds will be disbursed"
                        variant="outlined"
                        optionlist={disbursementAccountOptions}
                        onChange={(e) => {
                          setValue(
                            "disbursement_to_account",
                            e.target.value.toString()
                          );
                          if (
                            e.target.value.toString() ==
                            "disbursement_lender_account"
                          ) {
                            setShowStep4(false);
                            setShowStep5(false);
                            setShowStep6(false);
                          } else {
                            setShowStep4(true);
                            setShowStep5(true);
                          }
                          if (
                            e.target.value.toString() ==
                            "disbursement_lender_account"
                          ) {
                            setShowAccountType(true);
                          } else {
                            setShowAccountType(false);
                          }
                          onChangeDisbursementStep3();
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  {showAccountType && (
                    <Controller
                      name={`disbursement_account_type`}
                      control={control}
                      render={({ field }) => (
                        <CustomProductSelect
                          {...field}
                          label="Account Type"
                          variant="outlined"
                          optionlist={[
                            {
                              value: "savings",
                              label: "Savings",
                            },
                            {
                              value: "checking",
                              label: "Checking",
                            },
                          ]}
                        />
                      )}
                    />
                  )}
                </Grid>
              </Grid>
            )}
            {/* Step 4 */}
            {showStep4 && (
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12}>
                  <Controller
                    name={`disbursement_ach`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        sx={{ maxWidth: "800px" }}
                        label="4. Will disbursement be made using Happy Mango’s automatic ACH?"
                        variant="outlined"
                        optionlist={[
                          {
                            value: "YES",
                            label: "YES",
                          },
                          {
                            value: "NO",
                            label: "NO",
                          },
                        ]}
                        onChange={(e) => {
                          setValue(
                            "disbursement_ach",
                            e.target.value.toString()
                          );
                          if (e.target.value.toString() == "NO") {
                            setShowStep6(false);
                          } else {
                            setShowStep6(true);
                          }
                          onChangeDisbursementStep4();
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            )}
            {/* Step 5 */}
            {showStep5 && (
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12}>
                  <Controller
                    name={`disbursement_collect`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        sx={{ maxWidth: "800px" }}
                        label="5. Will the destination bank account number be collected on Happy Mango and displayed on system generated document ?"
                        variant="outlined"
                        optionlist={[
                          {
                            value: "YES",
                            label: "YES",
                          },
                          {
                            value: "NO",
                            label: "NO",
                          },
                        ]}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            )}
            {/* Step 6 */}
            {showStep6 && (
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12}>
                  <Controller
                    name={`use_disbursement_account`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        sx={{ maxWidth: "800px" }}
                        label="6. Please select origination account used for disbursing funds."
                        variant="outlined"
                        optionlist={accountOptions}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            )}
          </Box>
        )}
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          // disabled={!isDirty}
          disabled={!isActualDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
